<script>
import axios from 'axios'
export default
{
    name: 'mv-image-uploader',

    props:
    {
        text: String,

        // Default 840x560 3:2

        width: {
            type: Number,
            default: 840,
        },

        height: {
            type: Number,
            default: 560,
        },

        quality: {
            type: Number,
            default: 2,
        },

        type: null,
        noBrowser: Boolean,

    },

    methods:
    {
        upload()
        {
            this.image.generateBlob(blob =>{
                const formData = new FormData()
                const originalFile = this.image.getChosenFile()
                const fileName = originalFile && originalFile.name ? originalFile.name : 'blob'
                formData.append('file', blob, fileName)
                formData.append('type', this.type)
                const url =  `${process.env.API_SERVER}/attachments/upload-image`
                axios.post(url, formData).then(res => {
                    this.$emit('upload-done', res.data)
                    this.reset()
                }).catch(e => {
                    let errorString = ''
                    const error = e.response && e.response.data ? e.response.data : {}
                    if (error.message)
                    {
                        errorString = error.message
                    }
                    if (e.response && e.response.status == 429)
                    {
                        errorString = this.$t('ERROR.TOOMANYREQUEST')
                    }
                    if (e.response && e.response.status == 500)
                    {
                        errorString = this.$t('ERROR.APIERROR')
                    }
                    if (e.response && e.response.status == 503)
                    {
                        errorString = this.$t('ERROR.APIDEPLOY')
                    }
                    if (error.errors)
                    {
                        const first = error.errors[Object.keys(error.errors)[0]]
                        if (first && first[0])
                            errorString = first[0]
                    }
                    this.$snotify.error(errorString)
                })
            }, 'image/jpeg', 0.8)
        },

        reset()
        {
            this.image.remove()
        },

        selected(file)
        {
            this.$emit('upload-done', file)
        }
    },

    data()
    {
        return {
            image: {}
        }
    },

}
</script>
<template>
    <div>
        <mv-image-browser @selected="selected" v-if="!noBrowser">

        </mv-image-browser>
        <croppa
            class="text-center"
            v-model="image"
            :width="width / quality"
            :height="height / quality"
            :quality="quality"
            :placeholder="$t('GENERAL.UPLOAD')"
            placeholder-color="#222"
            :zoom-speed="10"
            prevent-white-space
            :show-remove-button="false"
            show-loading
            accept="image/*"
            />
        <div class="btn btn-sm btn-primary" v-show="image && image.imageSet" @click.prevent.stop="upload">
            <icon name="picture-o"></icon>
            {{ $t('GENERAL.SAVE') }}
        </div>

        <div class="btn btn-sm btn-secondary" v-show="image && image.imageSet" @click.prevent.stop="image.zoomIn">
            <icon name="search-plus"></icon>
        </div>

        <div class="btn btn-sm btn-secondary" v-show="image && image.imageSet" @click.prevent.stop="image.zoomOut">
            <icon name="search-minus"></icon>
        </div>

        <div class="btn btn-sm btn-danger" v-show="image && image.imageSet" @click.prevent.stop="reset">
            <icon name="times"></icon>
            {{ $t('GENERAL.DELETE') }}
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/components/ImageUploader.vue